<template lang="pug">
  .card-teaser.shadow-md(v-if="display === 'card'" :class="{ hover: mouseover }")  

    router-link(
      :to="path"
      @mouseover.native="hover"
      @mouseleave.native="blur"
    )
      figure
        img(v-if="showImage" v-lazy="image" :title="title" )
    
    div.content.p-4
      h3.text-base.font-bold(v-if="title")
        | {{ title }}
      .bait.text-sm(v-if="text" v-line-clamp:24="3")
        p.content(v-html="striptags(text)")
      .link
        router-link.btn.text-xs.my-2(:to="path") Weiterlesen
  .row-teaser(v-else :class="{ hover: mouseover }")
    .image
      router-link(
        :to="path"
        @mouseover.native="hover"
        @mouseleave.native="blur"
      )
        figure
          img(v-if="showImage" v-lazy="image" :title="title" )
    .text
      p.topic.is-uppercase.has-text-primary.has-text-weight-bold(v-if="topic")
        | {{ topic }}
      h3.title(v-if="title")
        | {{ title }}
      .bait(v-if="text" v-line-clamp:24="3")
        p.content(v-html="striptags(text)")
      .link
        router-link(:to="path") mehr ...
</template>

<script>
// import truncate from 'truncate-html';
import striptags from 'striptags';

import { get, trim } from '@/helpers';
import { fromUnixTime, format, parseISO } from 'date-fns';

export default {
    name: 'Teaser',
    data() {
        return {
            delay: 150,
            mouseover: false,
            showImage: true
        };
    },
    props: {
        teaser: {
            type: Object,
            required: true
        },
        display: {
            type: String,
            default: 'row'
        },
        showDate: {
            type: String,
            default: 'true'
        }
    },
    watch: {
        image() {
            // ugly workaround
            this.showImage = false;
            this.$nextTick(() => {
                this.showImage = true;
            });
        }
    },
    computed: {
        image() {
            let image;

            if (this.teaserSection) {
                const content = this.teaserSection.contents.find(content => content.key === 'image');
                if (content && content.images.length) image = content.images[0];
            }

            if (!image && this.sections.length) {
                this.sections.forEach(section => {
                    if (image) return;

                    const content = section.contents.find(content => content.key === 'image');
                    if (content && content.images.length) image = content.images[0];
                });
            }

            if (!image) return false;

            let storageRoute = `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`;
            storageRoute = trim(storageRoute, '/');

            let fit = get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1';
            const parameters = {
                // ... get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups')
            };
            let { w, h } = parameters;

            let width, height;
            let aspectRatio = 16 / 9;

            width = 320;
            height = width / aspectRatio;

            if (w && h) {
                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`);
            } else if (!w && !h) {
                fit += `&w=${width}&h=${height}`;
            }

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`
            };
        },
        path() {
            const categoryKey = get(this.teaser, 'category.key');
            const key = this.teaser.key;

            return `/${categoryKey}/${key}`;
        },
        createdAt() {
            const createdAt = get(this.teaser, 'created_at');
            if (createdAt) {
                const date = parseISO(format(fromUnixTime(createdAt), 'yyyy-MM-dd'));
                const formdate = format(new Date(date), 'MMM ee');
                const splitdate = formdate.split(' ');

                return splitdate;
            }
            return new Date();
        },

        topic() {
            return get(this.teaser, 'category.name');
        },
        title() {
            return get(this.teaser, 'title');
        },
        text() {
            // let text;
            let content;
            if (this.teaserSection) {
                content = this.teaserSection.contents.find(content => content.key === 'teaser');
            }

            if (!(content && content.text) && this.postSection) {
                content = this.postSection.contents.find(content => content.key === 'content');
            }

            // if (this.display === 'card') {
            //     text = truncate(content.text, 18, { byWords: true })
            // } else {
            //     text = truncate(content.text, 32, { byWords: true })
            // }

            return content.text;
        },
        sections() {
            return this.teaser.sections;
        },
        teaserSection() {
            return this.sections.find(section => section.key === 'category-page-teaser');
        },
        postSection() {
            return this.sections.find(section => section.key === 'post');
        }
    },
    methods: {
        hover() {
            this.$emit('focus', this.item);
            this.mouseover = true;
        },
        blur() {
            setTimeout(() => {
                this.$emit('blur', this.item);
                this.mouseover = false;
            }, this.delay);
        },
        striptags(html) {
            html = html.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '<br />');
            return striptags(html, ['a', 'i', 'u', 'b', 'em', 'strong', 'span', 'br']);
        }
    }
};
</script>

<style lang="sass" nolang="scss" scoped>

@import '~@/assets/sass/variables'

.card-teaser, .row-teaser

  text-align: initial
  h3.title
    @apply text-base font-semibold
    line-height: 1.3
    margin-bottom: 10px
    min-height: 30px
  p.topic
    @apply text-base font-semibold uppercase mb-3
    color: $isserstedt-blue2
  .bait
    margin-bottom: 20px
    word-break: normal !important
    br + br
      display: none
  .btn
    display: inline-block
    text-decoration: none
    background-color: #d0cec3
    color: #000

  figure
    position: relative
    width: 100%
    padding-bottom: 56.25% // 9 / 16
    display: block
    background: #D8D8D8
    margin-bottom: 10px
    img
      position: absolute
      width: 100%
      max-height: 100%
      left: 0
      top: 0

@screen md
  .row-teaser
    display: flex
    flex-direction: row
    .image
      flex-basis: 320px
      flex-grow: 0
      flex-shrink: 0
      figure
        margin-bottom: 0
    .text
      margin-left: 20px
      flex-grow: 1
      display: flex
      flex-direction: column
      .bait
        flex-grow: 1
</style>
